<template>
  <b-card>
    <!-- form -->
    <b-form>
      <b-row>
        <!-- type de paiment -->
        <b-col md="12">
          <b-form-group label-for="TypeDePaiement" label="Type de paiement ">
            <v-select
              id="TypeDePaiement"
              v-model="localOptions.paymentType"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              multiple
              label="title"
              :options="optionPaiement"
            />
          </b-form-group>
        </b-col>
        <!-- type de paiment -->
    
        <b-col sm="6">
          <b-form-group label="Nom du banque" label-for="bankName">
            <b-form-input
              v-model="localOptions.bankName"
              name="bankName"
              placeholder="Nom du banque"
            />
          </b-form-group>
        </b-col>
          <b-col sm="6">
          <b-form-group label="Code swift" label-for="swiftCode">
            <b-form-input
              v-model="localOptions.swiftCode"
              name="swiftCode"
              placeholder="Code swift"
            />
          </b-form-group>
        </b-col>
        <!-- devis -->
        <b-col md="6">
          <b-form-group label-for="devis" label="Devis">
            <v-select
              id="devis"
              v-model="localOptions.currency"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :options="currencyOption"
            />
          </b-form-group>
        </b-col>
        <!-- devis -->
          <b-col sm="6">
          <b-form-group label="IBan" label-for="iban">
            <b-form-input
              v-model="localOptions.iban"
              name="iban"
              placeholder="IBan"
            />
          </b-form-group>
        </b-col>


        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1"
            @click="saveSettings()"
          >
            Enregistrer
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import axios from "axios";
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BFormTextarea,
  BFormFile
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import Cleave from "vue-cleave-component";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

// eslint-disable-next-line import/no-extraneous-dependencies
import "cleave.js/dist/addons/cleave-phone.us";

export default {
  components: {
    BFormFile,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BFormTextarea,
    vSelect,
    flatPickr,
    Cleave,
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  props: {
    informationData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      optionPaiement: ["Compte bancaire", "PayPal", "Autre méthode"],
      currencyOption: ["TND", "EURO", "ESD"],
      localOptions: JSON.parse(JSON.stringify(this.informationData)),
      clevePhone: {
        phone: true,
        phoneRegionCode: "US",
      },
    };
  },
  methods: {

    resetForm() {
      this.localOptions = JSON.parse(JSON.stringify(this.informationData));
    },
    saveSettings() {
      console.log(JSON.stringify( this.localOptions));
      axios
        .put(
          `https://management-projects.herokuapp.com/api/users/${
            JSON.parse(localStorage.getItem("userData"))._id
          }`,
          this.localOptions
        )
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Utilisateur bien Modifié`,
              icon: "UserIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Erreur lors de la modification`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
          console.log(this.errorMessage);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
